import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "flex-start",
        flexDirection: "row",
        alignItems: "center"
    },
    bottomBar: {
        justifyContent: "flex-end",
        flexDirection: "row"
    },
    uploadPlaceholder: {
        justifyContent: "center",
        alignItems: "center"
    },
    modalOverlay: {
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        flex: 1
    },
    uploadBox: {
        justifyContent: "center",
        alignItems: "center",
        alignSelf: "center",
        overflow: "hidden",
        aspectRatio: 4 / 5,
        width: "100%",
        maxWidth: 360,
        ...webStyle({
            cursor: "pointer"
        })
    },
    lightboxCloseButton: {
        position: "absolute",
        zIndex: 10
    },
    tabsContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    editButton: {
        position: "absolute",
        zIndex: 10
    },
    switchRow: {
        flexDirection: "row",
        alignItems: "center"
    },
    uploadLimitText: {
        textAlign: "center"
    },
    uploadText: {
        textAlign: "center"
    },
    sectionContainer: {
        width: "100%"
    },
    lightboxImage: {
        height: "100%",
        width: "100%"
    },
    uploadPreview: {
        height: "100%",
        width: "100%"
    },
    imageUploadGrid: {
        width: "100%"
    },
    imageUploadCol: {
        flex: 1
    },
    formContainer: {
        width: "100%"
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
